import {Collection, Model} from './model';

export function Room(data, options) {
    Model.call(this, data, options);
    this.url = () => {
        if(!this._id && this.id){
            this._id = this.id
        }
        if (this._id) {
            return '/api/rooms/' + this._id;
        }
        return '/api/rooms';
    };

    this.getAttributes = () => {
        return {
            _id: this._id,
            name: this.name,
            topic: this.topic,
            parent: this.parent,
            deletedAt: this.deletedAt,
            timer: this.timer,
            participantsCount: this.participantsCount,
            isVisible: this.isVisible,
            urlID: this.urlID,
            isLocked: this.isLocked
        }
    };

    this.isMainRoom = () => {
        return this.parent === null;
    }
}

export function Rooms(collection) {
    this.model = Room;
    Collection.call(this, collection);

    this.url = '/api/rooms';
}
